// Auto-generated file - do not edit manually
export const LOCALE_HASH = 'ed0718be';
